import { createAction } from 'typesafe-actions'

import * as types from './types'

export const login = createAction(types.LOGIN)
export const logout = createAction(types.LOGOUT)
export const showAuthModal = createAction(types.SHOW_AUTH_MODAL)
export const hideAuthModal = createAction(types.HIDE_AUTH_MODAL)
export const register = createAction(types.NAVIGATE_TO_REGISTER)
export const newRoute = createAction(types.NAVIGATE_TO_NEW_ROUTE)
export const updateAuth = createAction(types.UPDATE_AUTH)
